import type { IconSize, IconSizeKey } from './types'

export const ICON_SIZES: Record<IconSizeKey, IconSize> = {
  sm: { width: 17, height: 20 },
  md: { width: 30, height: 40 },
  lg: { width: 40, height: 40 }
}
